import { render, staticRenderFns } from "./form-file.vue?vue&type=template&id=64b44f48&"
import script from "./form-file.vue?vue&type=script&lang=js&"
export * from "./form-file.vue?vue&type=script&lang=js&"
import style0 from "./form-file.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports